import {config} from "./config";


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function validatePriceFormat(value) {
  const regexp = new RegExp("^[0-9]+(.[0-9]{1,2})?$", "m");
  return regexp.exec(value) !== null;
}

export const getDiscount = (price: number | null, oldPrice: number | null): number | null => {
  const priceNumber = Number(price)
  const oldPriceNumber = Number(oldPrice)
  if (!priceNumber || !oldPriceNumber || isNaN(priceNumber) || isNaN(oldPriceNumber) || oldPriceNumber <= priceNumber) {
    return null;
  }
  
  return Math.floor(100 * (1 - priceNumber / oldPriceNumber));
};


export function parsePrice(price: number | string | null, decimalSeparator = ".\\,"): number | null {
  if (price === '') {
    return null
  }
  if (typeof price === "string") {
    const re = new RegExp("[^0-9\\" + decimalSeparator + "]+", "g");
    const parsedPrice = price.replace(re, "").replace(/[^0-9]/g, ".");
    if (validatePriceFormat(parsedPrice)) {
      return Number(parsedPrice);
    } else {
      return null
    }
  }
  return price;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const formatPrice = (price, currency = 'PLN', removeDecimals = true): string => {
  price = parsePrice(price)
  if (!price) {
    return ''
  }
  if (!currency) {
    return price
  }
  price = typeof price === 'number' ? price : Number(price.replace(',', '.'))
  
  switch (currency) {
    case 'CZK':
      price = price.toLocaleString('cs-CZ', {
        style: 'currency',
        currency: currency,
      })
      break
    case 'EUR':
      price = price.toLocaleString('sk-SK', {
        style: 'currency',
        currency: currency,
      })
      break
    case 'PLN':
      price = price.toLocaleString('pl-PL', {
        style: 'currency',
        currency: currency,
      })
      break
    case 'HUF':
      price = price.toLocaleString('hu-HU', {
        style: 'currency',
        currency: currency,
      })
      break
    case 'HRK':
      price = price.toLocaleString('cr-CR')
      break
    case 'UAH':
      price = price.toLocaleString('uk-UA', {
        currency: 'UAH',
        style: 'currency',
      })
      break
    case 'BGN':
      price = price.toLocaleString('bg-BG', {
        currency: 'BGN',
        style: 'currency',
      })
      break
    case 'RON':
      price = price.toLocaleString('ro-RO', {
        currency: 'RON',
        style: 'currency',
      })
      break
    default:
      return price
  }
  if (removeDecimals) {
    price = price.replace(',00', '').replace('.00', '')
  }
  return price
}


export const generateStaticImage = (imgUrl: string, width = 300, height = 300, crop = 'c0') => {
  const customerSymbol = config.customerSymbol
  imgUrl = imgUrl.split('?')[0]
  let burl = btoa(imgUrl)
  burl = burl.replace(/\//g, '_')
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return `https://qon-csts3.quartic.com.pl/${customerSymbol}/e1-${crop}/${width}x${height}/${burl.match(/.{1,32}/g).join('/')}.webp`
}
